import getProductHighlightList from 'Api/brief-live/getProductHighlightList';
import getProductHighlightListRequest from './model/request/getProductHighlightListRequest';
import getProductHighlightListResponse from './model/response/getProductHighlightListResponse';

const fetchProductHighlightList = async ({ queryClient, params }) => {
  const queries = getProductHighlightListRequest(params);
  const response = await queryClient.fetchQuery({
    queryKey: ['product-highlight-list', params],
    queryFn: () => getProductHighlightList(queries),
    gcTime: 0,
  });
  return getProductHighlightListResponse(response);
};

export default fetchProductHighlightList;
